module.exports = __webpack_public_path__ + "img/Advantages-background.28aff4fe.png";